var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFalling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 854 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 854,
    height: 480,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 480,
    fill: "#ff0089"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    width: 80,
    height: 478,
    fill: "#ff0089"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    width: 80,
    height: 475,
    fill: "#ff0089"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    width: 80,
    height: 470,
    fill: "#ff0089",
    opacity: 0.98
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    width: 80,
    height: 460,
    fill: "#ff0089",
    opacity: 0.95
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 400,
    width: 80,
    height: 410,
    fill: "#ff0089",
    opacity: 0.85
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 480,
    width: 80,
    height: 220,
    fill: "#ff0089",
    opacity: 0.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 560,
    width: 80,
    height: 100,
    fill: "#ff0089",
    opacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFalling);
export default __webpack_public_path__ + "static/media/Falling.ee7ae4993446542b62f414de00e02b1e.svg";
export { ForwardRef as ReactComponent };